(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["nc-slimcare-product"] && !Shopify.designMode) return;
  try {
    
function initSlimcare(){
 document.querySelectorAll('[data-slimcare]').forEach(root=>{
  if(root.dataset.ready)return;
  root.dataset.ready='true';
  const form=root.querySelector('[data-sp-form]');
  const buttons=root.querySelectorAll('[data-sp-order],[data-sp-sticky-order]');
  function update(){
   const selected=form.querySelector('input[name="id"]:checked');
   root.querySelector('[data-sp-sticky]').textContent=selected.dataset.pack==='triple'?'Rs. 6,350':'Rs. 2,490';
  }
  form.querySelectorAll('input[name="id"]').forEach(input=>input.addEventListener('change',update));
  root.querySelectorAll('[data-src]').forEach(button=>button.addEventListener('click',()=>{
   root.querySelector('[data-sp-image]').src=button.dataset.src;
   root.querySelector('[data-sp-image]').alt=button.dataset.alt;
   root.querySelectorAll('[data-src]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
  }));
  form.addEventListener('submit',()=>{buttons.forEach(b=>{b.disabled=true;b.textContent='Opening checkout…';});});
  window.addEventListener('pageshow',()=>{buttons.forEach(b=>{b.disabled=false;b.textContent='Order Now →';});});
  update();
 });
}
initSlimcare();
document.addEventListener('shopify:section:load',initSlimcare);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["np-playful"] && !Shopify.designMode) return;
  try {
    
function initNutrifierReviews(){document.querySelectorAll('.np-reviews').forEach(section=>{if(section.dataset.dotsReady)return;section.dataset.dotsReady='true';const track=section.querySelector('.np-cards'),cards=[...section.querySelectorAll('.np-card')],dots=[...section.querySelectorAll('.nc-dots button')];if(!track)return;dots.forEach((dot,i)=>dot.addEventListener('click',()=>track.scrollTo({left:cards[i].offsetLeft-cards[0].offsetLeft,behavior:'smooth'})));track.addEventListener('scroll',()=>{let index=0,distance=Infinity;cards.forEach((card,i)=>{const d=Math.abs(card.offsetLeft-cards[0].offsetLeft-track.scrollLeft);if(d<distance){distance=d;index=i}});dots.forEach((dot,i)=>dot.setAttribute('aria-current',i===index?'true':'false'))},{passive:true})})}initNutrifierReviews();document.addEventListener('shopify:section:load',initNutrifierReviews);

  } catch(e) { console.error(e); }
})();
})();
